// Romanian

export default {

  component: {
    jobAdList: {
      title: 'Posturi disponibile',
      jobs: 'Posturi',
      noJobAds: 'Momentan nu există posturi disponibile.',
    },

    jobAdCard: {
      openUntil: date => `Disponibil până la ${date}`,
    },

    jobAdGreetings: {
      thankYou: 'Mulțumim.',
      readyInfo: 'Aplicația ta a fost înregistrată, iar un recrutor te va contacta în scurt timp.',
      luck: 'Mult succes!',
    },

    jobAdSeeYou: {
      title: 'Mulțumim.',
      description: 'Cererea dumneavoastră de aplicare este salvată și v-am trimis un link pentru a continua aplicarea mai târziu.',
    },

    unpublished: {
      title: 'Nepublicat',
      info: 'Postul nu a fost publicat încă.',
    },
  },

  page: {},

}
